export enum ErrorCode {
  PasswordProtected = 'cb6e99cc-6a35-4993-8946-5779b9eded35',
  IncorrectPassword = '180626de-157c-42dd-ad99-d3cf19193f59',
}
